import type { FunctionComponent } from 'react';
import { defineMessages } from 'react-intl';

import ConsentLegalDisclaimer from '../../shared/agent-consent/LegalDisclaimer/LegalDisclaimer';

const messages = defineMessages({
  agreementHeader: {
    id: 'oauth.twg.legalDisclaimer.agreementHeader',
    defaultMessage: "By accepting, you agree to Atlassian's",
    description: 'TWG terms agreement line shown in the footer.',
  },
  agreementLinks: {
    id: 'oauth.twg.legalDisclaimer.agreementLinks',
    defaultMessage: '{privacyPolicyLink} and {termsOfUseLink}.',
    description:
      'TWG terms agreement links. The privacyPolicyLink and termsOfUseLink are replaced with actual links in the UI.',
  },
  privacyPolicy: {
    id: 'oauth.twg.privacyPolicy',
    defaultMessage: 'privacy policy',
    description: 'Text for the privacy policy link',
  },
  termsOfUse: {
    id: 'oauth.twg.termsOfUse',
    defaultMessage: 'terms of use',
    description: 'Text for the terms of use link',
  },
});

const LegalDisclaimer: FunctionComponent = () => (
  <ConsentLegalDisclaimer
    messages={{
      agreementHeader: messages.agreementHeader,
      agreementLinks: messages.agreementLinks,
      privacyPolicy: messages.privacyPolicy,
      termsOfUse: messages.termsOfUse,
    }}
  />
);

export default LegalDisclaimer;
